import { getNamespacedLogger } from '@mindtickle/ui-shell-core/Logger';
import { NAMESPACE } from './app.constants';

const logger = getNamespacedLogger(NAMESPACE);

export default logger;
